import { defineStore } from 'pinia';
import { walletBlockingReasons } from '~/constants';
import type {
  UserInfosType,
  PaymentFormInfosType,
  SddMandateInfosType,
  SavedCardsInfosType,
  RequestDebitType,
  VirtualIBANInfosType,
  VirtualIbanBodyType,
  StatusWalletType
} from '~/types';

export const useWalletsStore = defineStore('wallets', {
  state: () => ({
    userInfos: { balance: 0.0 } as UserInfosType,
    blockingReasons: undefined as number[] | undefined,
    openBlockUnblockWalletModal: false as boolean,
    openEditWalletStatusModel: false as boolean,
    openEditBankAccountStatusModel: false as boolean,
    status: { value: undefined as string | undefined },
    openAddDocumentModal: false as boolean,
    openEditDocumentModal: false as boolean,
    openAddBankAccountModal: false as boolean,
    openWireTransferModal: false as boolean,
    openDisablePaymentFormModal: true as boolean,
    openDisableModal: false as boolean,
    openEnableModal: false as boolean,
    openDisableSavedCard: false as boolean,
    openAddLogCommentModal: false as boolean,
    payementFormInfos: {} as PaymentFormInfosType,
    sddMandateInfos: {} as SddMandateInfosType,
    savedCardsInfos: {} as SavedCardsInfosType,
    disablePassword: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    enablePassword: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    },
    openViewPaymentFormModal: false as boolean,
    openRequestDebitModal: false as boolean,
    requestDebitInfos: {} as RequestDebitType,
    bankAccountId: undefined as number | undefined,
    openAddVirtualIbanModal: false as boolean,
    openAddPaymentFromModal: false as boolean,
    virtualIBANBody: {} as VirtualIbanBodyType,
    virtualIBANInfos: {} as VirtualIBANInfosType,
    wireTransferBody: {
      IbanId: undefined as undefined | number,
      AmountCC: { value: '' as string | number },
      Comment: { value: '' },
      Password: { value: '' },
      Wallet: null as null | string | undefined,
      Language: ''
    },
    statusBankAccountBody: {
      value: '' as string | undefined,
      isValid: undefined as boolean | undefined
    } as StatusWalletType,
    currentBankAccountId: undefined as number | undefined,
    walletIntId: undefined as number | undefined,
    openPostIdentLinkModal: false,
    generateKycLinkStep: 0,
    PostIdentLinkBody: {
      couponRequestedUrl: { value: '', isValid: false },
      declinedUrl: { value: '', isValid: false },
      incompleteUrl: { value: '', isValid: false },
      reviewPendingUrl: { value: '', isValid: false },
      successUrl: { value: '', isValid: false }
    },
    redirectUrl: '' as string
  }),
  actions: {
    handleOpenAddBankAccountModal() {
      this.openAddBankAccountModal = true;
    },
    handleCloseAddBankAccountModal() {
      this.openAddBankAccountModal = false;
    },
    handleOpenWireTransferModal() {
      this.openWireTransferModal = true;
    },
    handleCloseWireTransferModal() {
      this.openWireTransferModal = false;
    },
    toggleRequestDebitModal() {
      this.openRequestDebitModal = !this.openRequestDebitModal;
    },
    calculateBlockingReasonDisplay(rowData: { BlockingReasons: string }) {
      const { t } = useNuxtApp().$i18n;
      let blockingReasonDisplay = '';
      if (rowData.BlockingReasons) {
        const blockingReasonSet = new Set();

        rowData.BlockingReasons.split(', ').forEach((blockingReasonId: string): void => {
          blockingReasonSet.add(
            Object.keys(walletBlockingReasons).find((blockingReason: string): boolean =>
              walletBlockingReasons[blockingReason as keyof typeof walletBlockingReasons].includes(
                blockingReasonId
              )
            )
          );
        });

        blockingReasonDisplay = Array.from(blockingReasonSet)
          .map((value): string => t(`wallets.blockingReason.${value}`))
          .join(' / ');
      }

      return blockingReasonDisplay;
    }
  }
});
